/* eslint-disable max-len */
const en = {
  ACCEPT: 'Accept',
  ACCEPTED: 'Accepted',
  ACCEPTED_NEW: 'Accepted',
  ACCOUNT: 'Account',
  ACCOUNT_SETTINGS: 'Account Settings',
  ACTIVE: 'Active',
  ACTIVE_ORDERS: 'Active Orders',
  ADDITIONAL_CHARGE: 'Additional charge',
  ADDITIONAL_COMMENTS: 'Additional Comments',
  ADDITIONAL_MINUTES: 'Additional Minutes',
  ADDITIONAL_NOTES: 'Additional notes',
  ADDRESS: 'Address',
  ADDRESSES: 'Addresses',
  ADDRESS_CITY_OR_ZIP: 'Address, City or ZIP Code',
  ADDRESS_INELIGIBLE_DELIVERY: 'Sorry, this address is out of our delivery radius. Please enter a different address.',
  ADDRESS_INELIGIBLE_DELIVERY_PICK_UP_AVAILABLE: 'Sorry, this address is out of our delivery radius. Please enter a different address or select Pick up',
  ADDRESS_LINE_2: 'Address Line 2',
  ADDRESS_LINE_2_HINT: 'Enter Suite, Apt, Number, etc',
  ADDRESS_LINE_THREE: 'Address Line 3',
  ADDRESS_NOT_DELIVERABLE: 'Delivery not available for this address. Please enter a different address or',
  ADDRESS_TYPE: 'Address Type',
  ADD_ADDRESS: 'Add Address',
  ADD_EXISTING_CART: 'Add to Existing Cart',
  ADD_EXTRA: 'Add Extra',
  ADD_HOURS: 'Add hours',
  ADD_MENU_CATEGORY: 'Add Menu Category',
  ADD_MENU_ITEM: 'Add Menu Item',
  ADD_MODIFIER: 'Add Modifier',
  ADD_NEW: 'Add New',
  ADD_NEW_CARD: 'Add New Card',
  ADD_NEW_CATEGORY: 'Add New Category',
  ADD_NEW_F: 'Add New { value }',
  ADD_NEW_M: 'Add New { value }',
  ADD_PAYMENT_METHOD: 'Add Payment Method',
  ADD_TIP: 'Add a Tip',
  ADD_TO_CART: 'Add to Cart',
  ADD_TO_CART_ERROR: 'Something went wrong adding this item to your cart. Please try again later.',
  ADD_USER: 'Add User',
  ADJUST_ORDER_TIME: 'Adjust Order Time',
  ADJUST_TIME: 'Adjust time',
  ADMIN: 'Admin',
  ADMINISTRATOR: 'Administrator',
  ALL: 'All',
  ALLERGY_FRIENDLY: 'Allergy Friendly',
  ALLOW_DELIVERY: 'Allow Delivery',
  ALLOW_PICKUP: 'Allow Pickup',
  ALL_DISHES: 'All Dishes',
  ALL_TIME: 'All Time',
  ALREADY_HAVE_ACCOUNT: 'Already have an account?',
  AM: 'a.m.',
  ANALYTICS: 'Analytics',
  AND: 'and',
  APPLY: 'Apply',
  ARCHIVE: 'Archive',
  ARCHIVED: 'Archived',
  ARCHIVE_ACCOUNT: 'Archive Account',
  ARCHIVE_LOCATION: 'Archive Location',
  ARE_YOU_SURE_DELETE_ADDRESS: 'Are you sure you want to delete this address?',
  ARE_YOU_SURE_DELETE_PAYMENT_METHOD: 'By confirming, {cardBrand} ending in {lastFour} will be removed from your payment options. This will not cancel any of your open orders that use this payment method.',
  ASAP_DELIVERY_X: 'ASAP (~{value} minutes)',
  AVAILABILITY: 'Availability',
  AVAILABLE: 'Available',
  AVAILABLE_ALL_ORDERING_HOURS: 'Available during all ordering hours',
  AVG_REVENUE_PER_ORDER: 'Average Revenue Per Order',
  BACK: 'Back',
  BACK_TO_HOME: 'Back to Home',
  BILLING: 'Billing',
  BILLING_ADDRESS: 'Billing Address',
  BILLING_DELIVERY: 'Billing & Delivery',
  BILLING_DELIVERY_ADDRESS: 'Billing & Delivery Address',
  BUSINESS_HOURS: 'Business hours',
  BUSINESS_HOURS_DESC: 'Set your restaurant\u2019s business hours',
  BUSINESS_NAME: 'Business Name',
  BUSINESS_NAME_REQ: 'Business name is required',
  BUY_AGAIN: 'Buy again',
  CALL_DRIVER: 'Call Driver',
  CALL_US_AT: 'Call us at',
  CANCEL: 'Cancel',
  CANCELLED: 'Cancelled',
  CARD_DECLINED: 'Your card was declined',
  CARD_NUMBER: 'Card Number',
  CARD_NUMBER_REQ: 'A card number is required',
  CARD_UPDATE_ERROR: 'Failed to update card',
  CARD_X_ENDING_Y: '{cardBrand} ending in {lastFour}',
  CART_ITEM: 'Cart Item',
  CATEGORIES: 'Categories',
  CATEGORY: 'Category',
  CHANGE_LOCATION: 'Change Location',
  CHANGE_LOCATION_WARNING: 'Changing your location will empty your cart. Do you want to continue?',
  CHANGE_PASSWORD: 'Change Password',
  CHANGE_PASSWORD_DESCRIPTION: 'Update your password associated with your account.',
  CHANGE_PASSWORD_FOR: 'Change Password for',
  CHARGE_DELIVERY_ALL_ORDERS: 'Charge Delivery on All Orders',
  CHECKOUT: 'Checkout',
  CHECKOUT_GUEST_DESCRIPTION: 'or continue checking out as a <strong>Guest</strong>',
  CHECK_YOUR_EMAIL: 'Check your email',
  CHOOSE_PICKUP: 'choose pickup',
  CITY: 'City/Town',
  CITY_OR_ZIP: 'City or ZIP Code',
  CITY_REQ: 'City is required',
  CLEAR: 'Clear',
  CLEAR_SEARCH: 'Clear Search',
  CLICK_BUTTON_BELOW_RESET: 'Click the button below to reset it.',
  CLOSE: 'Close',
  CLOSED: 'Closed',
  CLOSES_AT: 'Closes at',
  CLOSE_PANEL: 'Close Panel',
  COMPLETE: 'Complete',
  COMPLETED: 'Completed',
  COMPLETED_ON_X: 'Completed on {date}',
  COMPLETED_ORDERS: 'Completed Orders',
  CONFIRM_NEW_PASSWORD: 'Confirm new password',
  CONFIRM_ORDER: 'Confirm Order',
  CONFIRM_ORDER_X: 'Confirm Order #{orderId}',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_TIME: 'Confirm time',
  CONTACT_DETAILS: 'Contact Details',
  CONTACT_FREE_DELIVERY: 'Contact-free Delivery',
  CONTACT_FREE_DELIVERY_DESC: 'Select this option and driver will drop off order, then notify you.',
  CONTACT_FREE_DELIVERY_X: 'Contact-free Delivery to {value}',
  CONTACT_INFORMATION: 'Contact Information',
  CONTACT_US: 'Contact us',
  CONTAINS_NUTS: 'Contains Nuts',
  CONTINUE: 'Continue',
  CONTINUE_AS_GUEST: 'Continue as Guest',
  CONTINUE_CHECKOUT: 'Continue to Checkout',
  CONTINUE_CHECKOUT_VALUE: 'Continue to checkout: {value}',
  CONTINUE_GUEST: 'Continue as Guest',
  CONTINUE_GUEST_DESC: 'You don\'t need an account to checkout',
  CONTINUE_PAYMENT: 'Continue to Payment',
  CONTINUE_SHOPPING: 'Continue Shopping',
  COUNTRY: 'Country',
  CREATE: 'Create',
  CREATE_ACCOUNT: 'Create your account',
  CREATE_ACCOUNT_ALT: 'Create Account',
  CREATE_ACCOUNT_CHECKOUT_DISCLAIMER: 'By creating an account, you agree to our',
  CREATE_ACCOUNT_DESC: 'Don\'t have an account?',
  CREATE_ACCOUNT_FASTER_CHECKOUT: 'Create an account for faster checkout next time',
  CREATE_ONE: 'Create one',
  CREDITED_TO: 'Credited to',
  CURBSIDE_PICKUP: 'Curbside Pickup',
  CURBSIDE_PICKUP_AT: 'Curbside Pickup at {value}',
  CURBSIDE_PICKUP_CUSTOMER_DESC: 'Select this option to have a member of our staff bring the order to your vehicle.',
  CURBSIDE_PICKUP_DESC: 'Enable this to allow customers to request a curbside pickup at checkout, and notify them to call the store when they are outside.',
  CURBSIDE_PICKUP_X: 'Curbside Pickup from {value}',
  CURRENTLY_NOT_ACCEPTING_ONLINE_ORDERS: 'Sorry, we are currently not accepting online orders',
  CURRENTLY_UNAVAILABLE: 'Currently Unavailable',
  CURRENT: 'Current',
  CURRENT_PASSWORD: 'Current password',
  CURRENT_PASSWORD_REQUIRED: 'Current password is required to change password',
  CUSTOM: 'Custom',
  CUSTOMER_MAY_NOT_SEE_REFUND_FOR_5_10_DAYS: 'Customer may not see this refund for 5-10 days',
  CUSTOMER_REQUESTS_CONTACT_FREE_DELIVERY: 'Customer has requested Contact-Free Delivery',
  CUSTOMER_WILL_RECEIVE_NOTIFICATION_ADJUSTED_TIME: 'Customer will receive a notification with the new adjusted time',
  CUSTOM_ORDERING_HOURS: 'Custom Ordering Hours',
  CUSTOM_ORDERING_HOURS_DESC: 'Turn this on to override and set custom ordering hours.',
  CUSTOM_TIME: 'Custom Time',
  CUSTOM_TIP_AMOUNT: 'Custom tip amount',
  CVC: 'CVC',
  DARK: 'Dark',
  DAY: 'Day',
  DEFAULT_BILLING_DELIVERY: 'Default Billing & Delivery Address',
  DEFAULT_STORE_LOCATION: 'Default Store Location',
  DEFAULT_X: 'Default {value}',
  DELETE: 'Delete',
  DELETE_ACCOUNT: 'Delete Account',
  DELETE_ACCOUNT_CONFIRMATION: 'Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone.',
  DELETE_ACCOUNT_DESCRIPTION: 'No longer want to use our service? You can delete your account here. This action is not reversible. All information related to this account will be deleted permanently.',
  DELETE_ACCOUNT_YES: 'Yes, delete my account',
  DELETE_ADDRESS: 'Delete this address',
  DELETE_PAYMENT_METHOD: 'Delete this payment method?',
  DELETE_PAYMENT_METHOD_DESC_X: 'By confirming, {cardType} ending in {lastFour} will be removed from your payment options. This will not cancel any of your open orders that use this payment method.',
  DELIVER: 'Deliver',
  DELIVERED: 'Delivered',
  DELIVERED_AT: 'Delivered at',
  DELIVERED_BY: 'Delivered by',
  DELIVERY: 'Delivery',
  DELIVERY_AREA_RADIUS_MI: 'Delivery area radius (miles)',
  DELIVERY_AT: 'Delivery at',
  DELIVERY_CONFIRMATION: 'Delivery Confirmation',
  DELIVERY_FEE: 'Delivery fee',
  DELIVERY_FEES: 'Delivery Fees',
  DELIVERY_FEE_AMOUNT: 'Delivery fee amount',
  DELIVERY_FEE_DEFAULT: 'Delivery fee for all other orders',
  DELIVERY_BEING_REASSIGNED: 'Delivery Being Reassigned',
  DELIVERY_BEING_REASSIGNED_DESC: 'Your delivery is being reassigned to another driver. Tracking will resume shortly.',
  DELIVERY_INFORMATION: 'Delivery Information',
  DELIVERY_INSTRUCTIONS: 'Delivery Instructions',
  DELIVERY_INSTRUCTIONS_PLACEHOLDER: 'E.g., Gate code: 1234, leave at back door',
  DELIVERY_PHOTO: 'Delivery Photo',
  DELIVERY_PICKUP_ADDRESSES: 'Delivery / Pickup Addresses',
  DELIVERY_TRACKING: 'Delivery Tracking',
  DELIVERY_TIME: 'Delivery Time',
  DELIVERY_TO: 'DELIVERY to',
  DELIVERY_TO_X: 'Delivery to {value}',
  DELIVERY_X: 'Delivery to {value}',
  DELIVER_FROM_HERE: 'Deliver from here',
  DELIVER_IN: 'Deliver in',
  DESCRIPTION: 'Description',
  DETAILS: 'Details',
  DIETARY_OPTIONS: 'Dietary Options',
  DISCOUNT: 'Discount',
  DISCOUNT_CODE: 'Discount Code',
  DISMISS_ALERT: 'Dismiss Alert',
  DRIVER_HAS_ARRIVED: 'Your driver has arrived!',
  DONT_HAVE_ACCOUNT: 'Don\'t have an account?',
  EDIT: 'Edit',
  EDIT_ADDRESS: 'Edit Address',
  EDIT_CATEGORY: 'Edit Category',
  EDIT_F: 'Edit {value}',
  EDIT_IMAGE: 'Edit Image',
  EDIT_MENU_ITEM: 'Edit Menu Item',
  EDIT_ORDER: 'Edit Order',
  EDIT_PAYMENT_METHOD: 'Edit payment method',
  EDIT_USER: 'Edit User',
  EMAIL: 'Email',
  EMAIL_ADDRESS: 'Email Address',
  EMAIL_CONFIRMATION_WITH_PASSWORD: 'An email confirmation with a password will be sent to this email address',
  EMAIL_SENT_TO: 'Email sent to',
  EMAIL_THANK_YOU_FOR_REGISTERING: 'Thank you for registering with {value}. You can now log in to your account for faster checkout!',
  EMAIL_WELCOME_NEW_STORE_USER: 'You have been added as a user for {value}. To activate your account, click the button below',
  EMPTY_BAG: 'Empty Bag',
  EMPTY_CART: 'Empty Cart',
  ENABLE_MARKETING_NOTIFICATIONS: 'Enable Marketing Notifications',
  ENABLE_MARKETING_NOTIFICATIONS_DESCRIPTION: 'Get text alerts about new products, discounts, and sales',
  ENABLE_PRINTER: 'Enable Printer',
  ENABLE_PRINTER_DESC: 'Activate to send a copy of each order receipt to the printer',
  ENABLE_SMS_NOTIFICATIONS: 'Enable SMS Notifications',
  ENABLE_SMS_NOTIFICATIONS_DESCRIPTION: 'Get SMS notifications with status updates about your orders',
  END_DATE: 'End Date',
  ENTER_EXPIRATION_DATE: 'Please enter the expiration date',
  ENTER_LOCATION_DETAILS: 'Enter City, State or ZIP Code',
  ENTER_NAME_EMAIL: 'Enter Name or Email',
  ENTER_NEW_PASSWORD: 'Enter new password',
  ENTER_PASSWORD: 'Please enter a password',
  ENTER_STRONGER_PASSWORD: 'Please enter a stronger password',
  ENTER_VALID_CVC: 'Please enter a valid CVC number',
  ENTER_VALID_EMAIL: 'Please enter a valid email',
  ENTER_VALID_EXPIRATION_DATE: 'Please enter a valid expiration date',
  ENTER_VALID_NUMBER: 'Please enter a valid number (Only digits and decimals are accepted)',
  ENTER_VALID_POSTAL_CODE: 'Please enter a valid zip code',
  ENTER_YOUR_EMAIL: 'Please enter your email',
  ERROR_PROCESSING_PAYMENT_CUSTOMER_WILL_BE_NOTIFIED: 'There was an error processing the payment for this order. The customer will be notified.',
  ESTIMATED_DELIVERY_TIME_X: 'We estimate it will be ready for delivery at {value} and should be with you shortly after that.',
  ESTIMATED_PICKUP_TIME_X: 'We estimate it will ready for pickup at {value}.',
  ETA_MINUTES: 'Arriving in {minutes} min',
  EXPIRED_CARD: 'Your card has expired',
  EXPIRES: 'Expires',
  EXPRESS_CHECKOUT: 'Express Checkout',
  EXP_DATE: 'Expiration Date',
  EXTRAS: 'Extras',
  EXTRAS_ARE_X: 'Extras are {value} each',
  FEES: 'Fees',
  FIELD_REQ: 'This field is required',
  FILL_REQ_FIELDS: 'Please fill out all required fields',
  FIND_LOCATION: 'Find a location',
  FIND_STORE: 'Find a Store',
  FIRST_NAME: 'First name',
  FORGOT_PASSWORD: 'Forgot Password?',
  FRAUDULENT: 'Fraudulent',
  FREE: 'FREE',
  FREE_DELIVERY: 'Free delivery',
  FREE_DELIVERY_MIN_AMOUNT: 'Free delivery minimum amount',
  FREE_DELIVERY_MIN_X: '{value} minimum for FREE delivery',
  FRI: 'Friday',
  FRIDAY: 'Friday',
  FULL_HOURS: 'Full Hours',
  GENERAL_SETTINGS: 'General Settings',
  GETTING_COOKED: 'Getting cooked',
  GET_STARTED_DELIVERY_METHOD: 'To get started, select an option:',
  GET_STARTED_ENTER_ADDRESS: 'To get started, enter your address:',
  GLUTEN_FREE: 'Gluten-free',
  GMB_ENTER_LOCATION_HINT: 'Enter first line of street address, excluding Suite, Apt, Number, etc.',
  GO_TO_CHECKOUT: 'Go to Checkout',
  GRATUITY: 'Gratuity',
  GRATUITY_DESC: 'Allow customers to leave a tip at checkout.',
  HIDE_DETAILS: 'Hide Details',
  HOME: 'Home',
  HOURS_FOR_X: 'Hours for {value}',
  IMAGE: 'Image',
  IMAGES_SELECTED_X: '({number}) images selected.',
  IMPORTANT_ORDER_UPDATE: 'Important update about your order',
  INCOMING: 'Incoming',
  INCOMPLETE_CARD_NUMBER: 'Incomplete card number',
  INCOMPLETE_CVC: 'Your card\'s security code is incomplete.',
  INCOMPLETE_EXPIRY: 'Your card\'s expiration date is incomplete.',
  INCOMPLETE_NUMBER: 'The card number is incomplete',
  INCORRECT_CVC: 'Your card\'s security code is incorrect.',
  INSTALL_APP: 'Add to Home Screen',
  INVALID_CREDENTIALS: 'The password and/or username you enter is incorrect',
  INVALID_CURRENT_PASSWORD: 'Current password is incorrect',
  INVALID_DISCOUNT_CODE: '{value} is not a valid discount code',
  INVALID_EXPIRY_MONTH: 'The card\'s expiration month is invalid',
  INVALID_EXPIRY_YEAR: 'The card\'s expiration year is invalid',
  INVALID_EXPIRY_YEAR_PAST: 'The card\'s expiration year is in the past',
  INVALID_NUMBER: 'The card number is invalid',
  INVALID_PHONE_NUMBER: 'Invalid Phone Number',
  INVALID_TOKEN: 'Reset token is invalid or expired',
  IN_PROGRESS: 'In Progress',
  IN_PROGRESS_ORDERS: 'In Progress Orders',
  IN_STOCK: 'In Stock',
  IN_TRANSIT: 'In Transit',
  ITEMS_SUBTOTAL: 'Items subtotal',
  ITEM_CURRENTLY_OUT_OF_STOCK: 'This item is currently out of stock',
  ITEM_ONLY_AVAILABLE_ON: 'This item is only available on {days}',
  I_COME_INSIDE: 'I\'ll come inside',
  KITCHEN_CLOSED: 'Kitchen Closed',
  LAST30DAYS: 'Last 30 Days',
  LAST7DAYS: 'Last 7 Days',
  LAST_NAME: 'Last name',
  LAST_WEEK: 'Last Week',
  LEAVE_AT_MY_DOOR: 'Leave at my door',
  LIGHT: 'Light',
  LIMITED_AVAILABILITY: 'Limited availability',
  LINK: 'Link',
  LOADING_X: 'Loading {value}...',
  LOCATIONS: 'Locations',
  LOCATION_DETAILS: 'Location Details',
  LOCATION_MANAGER: 'Location Manager',
  LOCATION_NAME: 'Location Name',
  LOCATION_SETTINGS: 'Location Settings',
  LOGIN: 'Login',
  LOG_IN_TO_YOUR_ACCOUNT: 'Login to your account',
  LOG_OUT: 'Log out',
  LOW_CALORIE: 'Low Calorie',
  MAC_ADDRESS: 'MAC Address',
  MAKE_THIS_YOUR_STORE: 'Make this your store',
  MANAGE_ORDERS: 'Manage Orders',
  MANAGE_USERS: 'Manage Users',
  MANAGE_USER_PERMISSIONS: 'Manage User Permissions',
  MARK_ALL_READ: 'Mark all as read',
  MENU_CATEGORY_NAME: 'Menu category name',
  MENU_ITEM: 'Menu Item',
  MENU_ITEMS_ECOM: 'Menu Items',
  MENU_ITEM_ECOM: 'Menu Item',
  MENU_ITEM_GROUP_EXTRAS_DESC: 'Additional options or ingredients (ex. add cheese)',
  MENU_ITEM_GROUP_MODIFIERS_DESC: 'Ingredients or options that can be removed (ex. no onions)',
  MENU_ITEM_GROUP_OPTS_DESC: 'Varying options for a customer to select (ex. chicken or beef)',
  MESSAGE_FROM_RESTAURANT: 'Message from Restaurant',
  MINUS_ONE: 'Minus one',
  MINUTES: 'minutes',
  MIN_ORDER_AMOUNT: 'Minimum order amount',
  MODIFIERS: 'Modifiers',
  MON: 'Monday',
  MONDAY: 'Monday',
  MONTH: 'Month',
  MOST_RECENT: 'Most Recent',
  MY_ACCOUNT: 'My Account',
  MY_ORDERS: 'My Orders',
  NAME_ON_CARD: 'Name on Card',
  NET_AMOUNT: 'Net Amount',
  NEW: 'New',
  NEWEST_FIRST: 'Newest First',
  NEW_CUSTOMERS: 'New Customers',
  NEW_ORDER: 'New Order',
  NEW_ORDERS: 'New Orders',
  NEW_PASSWORD: 'New password',
  NEW_PASSWORD_AVAILABLE_DESC: 'You can now use your new password to login to your account.',
  NEW_SCHEDULED_ORDER: 'New Scheduled Order',
  NEXT: 'Next',
  NONE: 'None',
  NOTE_TO_CUSTOMER_OPT: 'Note to customer (optional)',
  NOTIFICATIONS: 'Notifications',
  NOT_ACCEPTING_ORDERS: 'Currently not accepting orders',
  NOT_AVAILABLE: 'Not available',
  NOT_A_MEMBER: 'Not a member?',
  NOT_NOW: 'Not right now',
  NO_CONTACT_DELIVERIES: 'No-Contact Deliveries',
  NO_INSTRUCTIONS: 'No delivery instructions',
  NO_CONTACT_DELIVERIES_DESC: 'Enable to allow customers to select no-contact delivery and add instructions for the courier at checkout.',
  NO_MATCH_PASSWORDS: 'New password and confirm password doesn\'t match',
  NO_ORDERS: 'No Orders',
  NO_PAID_ORDERS: 'No paid orders',
  NO_PRODUCTS_FOUND: 'No products found',
  NO_REVENUE: 'No revenue',
  NO_USERS_FOUND_WITHIN_CRITERIA: 'No users found within your search criteria.',
  NO_X_FOUND_FILTER: 'No {value} found within your search criteria!',
  OK: 'OK',
  OLDEST: 'Oldest',
  OLDEST_FIRST: 'Oldest First',
  ONE_ITEM: '1 Item',
  ONE_ITEM_IN_YOUR_BAG: '1 item in your bag',
  ONE_MINUTE: '1 minute',
  ONLINE_ORDERING: 'Online Ordering',
  ONLINE_ORDERING_HINT: '<strong>WARNING!</strong> Turning this off will override any set hourly schedule. Customers can continue to browse the menu, but cannot place an order.',
  OPEN: 'Open',
  OPENS_AT: 'Opens at',
  OPEN_ALL_WEEK: 'Open 24/7',
  OPTION: 'Option',
  OPTIONAL: 'Optional',
  OPTIONS: 'Options',
  OR: 'or',
  ORDER: 'Order',
  ORDERING_HOURS: 'Ordering Hours',
  ORDERING_HOURS_DESC: 'Your ordering hours are automatically calculated based on your business hours and prep time.',
  ORDERING_HOURS_DISCLAIMER: 'Remember to consider cooking/preparation time when choosing ordering hours. For example if you normally close the restaurant kitchen at 5pm, you might want to set last orders to 4.30pm to allow for preparation.',
  ORDERS: 'Orders',
  ORDERS_X: 'Orders for {value}',
  ORDER_ACCEPTED_DESC: 'Great news! Your order was accepted by the ' +
    'restaurant. We are working on your order and will notify you when it\'s ' +
    'ready.',
  ORDER_ACCEPTED_HEADLINE: 'Your order is being prepped!',
  ORDER_AMOUNT: 'Order Amount',
  ORDER_BEING_PREPPED_ETA: 'Your order is currently being fulfilled and has a prep time of',
  ORDER_DELIVERED_DESC: 'Your order has been delivered to',
  ORDER_DELIVERED_HEADLINE: 'Your order has been delivered!',
  ORDER_DETAILS: 'Order Details',
  ORDER_DIALOG_HEADLINE: 'To get started, find a location:',
  ORDER_ETA_HEADING_X: 'When will this order be ready for {value}',
  ORDER_ETA_UPDATED_X: 'Due to a surge in orders, your updated pickup time is <u>{value}</u>',
  ORDER_HISTORY: 'Order history',
  ORDER_HOURS_DISCLAIMER: 'Remember to consider prep time for delivery vs pickup, when allowing customers to place orders. For example, if you normally close the kitchen at 5pm you might want to set last delivery orders to an earlier time to allow for prep and delivery.',
  ORDER_IN_TRANSIT_HEADLINE: 'Your order is on the way!',
  ORDER_NEW_DESC: 'Your order is being reviewed. Once approved, you will receive an email confirmation and updated order status.  ',
  ORDER_NEW_HEADLINE: 'Your order has been received and is currently being reviewed!',
  ORDER_NOTIFICATIONS: 'Order Notifications',
  ORDER_NOW: 'Order now',
  ORDER_NUM: 'Order #',
  ORDER_NUMBER: 'Order Number',
  ORDER_NUMBER_REQUIRED: 'Please enter an order number',
  ORDER_PLACED: 'Order placed',
  ORDER_PLACED_BIZ_DESC: 'A new order was placed on {value} for',
  ORDER_QUESTIONS: 'Questions about your order?',
  ORDER_READY_DELIVERY_DESC: 'Your order will be delivered to',
  ORDER_READY_HEADLINE: 'Your order is being made!',
  ORDER_READY_PICKUP_DESC: 'Your order is ready for pickup at',
  ORDER_READY_PICKUP_HEADLINE: 'Your order is ready for pickup!',
  ORDER_REFUND_HEADLINE: 'Your refund request',
  ORDER_REJECTED_DESC: 'We are sorry to tell you that we were not able to fulfill your order. You will not be charged.',
  ORDER_REJECTED_HEADLINE: 'We could not fulfill your order',
  ORDER_SCHEDULE: 'Order Schedule',
  ORDER_SCHEDULED_BIZ_DESC: 'A new order was scheduled for {value} for',
  ORDER_SCHEDULING: 'Order Scheduling',
  ORDER_SCHEDULING_DESC: 'Allow customers to schedule an order for a specific time and date.',
  ORDER_SETTINGS: 'Order Settings',
  ORDER_SUMMARY: 'Order Summary',
  ORDER_TYPE: 'Order Type',
  ORDER_UPDATE: 'Order Update',
  ORDER_WILL_BE_READY_FOR_DELIVERY_TO_X_ADDRESS: 'Your order is scheduled for delivery at <b>{time}</b> to <b>{address}</b>',
  ORDER_WILL_BE_READY_FOR_PICKUP_AT_X_ADDRESS: 'Your order will be ready for pickup at <b>{time}</b> at <b>{address}</b>',
  ORDER_X: 'Order #{value}',
  ORDER_X_ACCEPTED: '<b>Order #{orderId}</b> was accepted',
  ORDER_X_DELIVERED: '<b>Order #{orderId}</b> has been delivered',
  ORDER_X_PICKED_UP: '<b>Order #{orderId}</b> has being picked up',
  ORDER_X_PLACED: '<b>Order #{orderId}</b> was placed',
  ORDER_X_READY_DELIVERY: '<b>Order #{orderId}</b> is ready to be delivered',
  ORDER_X_READY_PICKUP: '<b>Order #{orderId}</b> is ready for pickup',
  ORDER_X_REFUNDED: '<b>Order #{orderId}</b> was refunded',
  ORDER_X_REJECTED: '<b>Order #{orderId}</b> was rejected',
  ORDER_X_SCHEDULED: '<b>Order #{orderId}</b> was scheduled',
  OR_CHECKOUT_AS_GUEST: 'or continue as a guest',
  OTHER: 'Other',
  OUT_OF_STOCK: 'Sold Out',
  OUT_OF_STOCK_ALL_LOCS: 'Out of Stock in All Locations',
  OUT_OF_STOCK_DESC: 'Select locations in which this item is out of stock',
  OUT_OF_STOCK_SETTINGS: 'Out of Stock Settings',
  OVERVIEW: 'Overview',
  PAGE_COMING_SOON: 'We\'re working hard to make this website',
  PAGE_COMING_SOON_DESCRIPTION: 'Come back in a few days and you will find a new design very soon!',
  PAGE_NOT_FOUND: 'Page Not Found',
  PAGE_NOT_FOUND_DESCRIPTION: 'Sorry, we couldn\'t find the page you’re looking for.',
  PAID_ORDERS: 'Paid Orders',
  PASSWORD: 'Password',
  PASSWORD_EXTREMELY_GUESSABLE: 'Your password is extremely guessable',
  PASSWORD_SOMEWHAT_GUESSABLE: 'Your password somewhat guessable',
  PASSWORD_SUCCESSFULLY_RESET: 'Your password was reset successfully',
  PASSWORD_UPDATED_SUCCESSFULLY: 'Password updated successfully',
  PASSWORD_VERY_GUESSABLE: 'Your password is very guessable',
  PAST_ORDERS: 'Past orders',
  PAUSE_ORDERING: 'Pause Ordering',
  PAUSE_ORDERING_DESC: 'Use this to override any set hourly schedule. When enabled, customers can continue to browse the menu but cannot place an order.',
  PAYING_METHOD_X_Y: 'PAID with {cardBrand} ending in {lastFour}',
  PAYMENT: 'Payment',
  PAYMENT_CANCELED: 'Payment canceled',
  PAYMENT_FAILED: 'Payment failed',
  PAYMENT_FORM_LOAD_ERROR: 'We’re having trouble loading the payment form. Please refresh the page and try again. If the problem continues, {0} and we’ll be happy to help.',
  PAYMENT_INFORMATION: 'Payment Information',
  PAYMENT_METHOD: 'Payment Method',
  PAYMENT_METHODS: 'Payment Methods',
  PAYOUTS: 'Payouts',
  PAYOUT_STATUS: 'Payout Status',
  PENDING_ORDERS: 'Pending Orders',
  PERM_DELETE_LOCATION: 'Delete Location Permanently',
  PERSONAL_INFORMATION: 'Personal Information',
  PHONE_NUMBER: 'Phone Number',
  PHONE_NUMBER_DISCLAIMER: 'By providing your phone number, you consent to receive text messages from {value} related to your order. Standard message rates apply.',
  PICKED_UP: 'Picked Up',
  PICKUP: 'Pickup',
  PICKUP_AT: 'Pickup at {value}',
  PICKUP_DELIVERY: 'Pickup or delivery',
  PICKUP_FROM: 'PICKUP from',
  PICKUP_FROM_X: 'Pickup from {value}',
  PICKUP_IN: 'Pickup in',
  PICKUP_INSTRUCTIONS: 'Pickup Instructions',
  PICKUP_IN_STORE: 'Pickup in store',
  PICKUP_SETTINGS: 'Pickup Settings',
  PICKUP_SETTINGS_DISCLAIMER: 'Provide instructions for your customers so they know how to pickup their orders. (ex. where to go in store, if they need a name and order number, etc.)',
  PICKUP_TIME: 'Pick up time',
  PICKUP_X: 'Pickup from {value}',
  PLACE_ORDER: 'Place Your Order',
  PLEASE_CHECK_SPAM: 'Please check you spam folder if message does not appear within 15 minutes',
  PLEASE_ENTER_A_BIGGER_NUMBER: 'Please enter a bigger number',
  PLEASE_ENTER_A_SMALLER_NUMBER: 'Please enter a smaller number',
  PLEASE_ENTER_A_WHOLE_NUMBER: 'Please enter a whole number',
  PLEASE_ENTER_VALID_PRICE: 'Please enter a valid price',
  PLEASE_SELECT_A_VALID_ADDRESS: 'Please select a valid address',
  PLEASE_SET_DELIVERY_LOCATION: 'Please set delivery location',
  PM: 'p.m.',
  PLUS_ONE: 'Plus one',
  POSTAL_CODE: 'Postal Code',
  PREFERENCES: 'Preferences',
  PREP_TIME: 'Prep time',
  PREP_TIME_DISCLAIMER: 'Estimated prep time is used to give an indication to the customer when the order might be ready. You have the option to override this default each time an order is received.',
  PRICE: 'Price',
  PRICE_HIGHEST: 'Price: Low to High',
  PRICE_LOWEST: 'Price: High to Low',
  PRIMARY: 'Primary',
  PRINT: 'Print',
  PRINTING: 'Printing...',
  PRINT_RECEIPT: 'Print Receipt',
  PRIVACY: 'Privacy',
  PRIVACY_POLICY: 'Privacy Policy',
  PROCESSED: 'Processed',
  PROCESSING: 'Processing',
  PROCESSING_ERROR: 'An error occurred while processing your card. Try again in a little bit.',
  PRODUCTS: 'Products',
  PRODUCT_INFORMATION: 'Product Information',
  PRODUCT_NOT_AVAILABLE: '{product} is not available.',
  PRODUCT_NOT_AVAILABLE_AT_SELECTED_TIME: 'Some items in your bag are not available during the selected time. Continuing may result in these items being removed from your order.',
  PRODUCT_SOLD_OUT_ERROR: 'Sorry for the inconvenience. This item is sold out or no longer available.',
  PROFILE: 'Profile',
  QUANTITY: 'Quantity',
  READY: 'Ready',
  READY_DELIVERY: 'Ready for Delivery',
  READY_PICKUP: 'Ready for Pickup',
  RECEIVED_X: 'Received on {x}',
  RECENT_TRANSACTIONS: 'Recent Transactions',
  REFUND: 'Refund',
  REFUNDED: 'Refunded',
  REFUND_DESC: 'We have processed your refund request. Please note it might take up to <strong>5 business days</strong> for the money to appear back in your account.',
  REFUND_ISSUED_SUCCESS: 'Refund successfully issued',
  REFUND_PAYMENT: 'Refund Payment',
  REGISTER: 'Register',
  REGISTER_NOW: 'Register now \u203A',
  REJECT: 'Reject',
  REJECTED: 'Rejected',
  REJECTED_: 'Rejected',
  REJECTED_ON_X: 'Rejected on {date}',
  REJECTED_ORDERS: 'Rejected Orders',
  REJECT_ORDER_X: 'Reject Order #{orderId}',
  REMOVE: 'Remove',
  REMOVE_ADDRESS: 'Remove Address',
  REMOVE_IMAGE: 'Remove Image',
  REMOVE_USER: 'Remove User',
  REMOVE_USER_CONFIRMATION: 'Are you sure you want to remove this user?',
  REMOVE_X: 'Remove { value }',
  REORDER: 'Reorder',
  REQUESTED_BY_CUSTOMER: 'Requested by customer',
  REQUIRED: 'Required',
  RESET_PASSWORD_SENT_DESC: 'We have sent you a password reset link to the email address you have provided.',
  RESET_YOUR_PASSWORD: 'Reset your password',
  RESTAURANT_SETTINGS: 'Restaurant Settings',
  RETURNING_CUSTOMERS: 'Returning Customers',
  REVENUE: 'Revenue',
  REVIEW: 'Review',
  REVIEW_ORDER_DESC: 'Review address, payments, and tip before placing your order.',
  REVIEW_ORDER_DESC_NO_TIP: 'Review address and payments before placing your order.',
  ROLE: 'Role',
  SAT: 'Saturday',
  SATURDAY: 'Saturday',
  SAVE: 'Save',
  SAVE_CONTINUE: 'Save and Continue',
  SAVE_PAYMENT_DESC: 'Save this payment method for future transactions',
  SAVING: 'Saving...',
  SAVING_USER: 'Saving user...',
  SCHEDULED: 'Scheduled',
  SCHEDULED_ACCEPTED: 'Scheduled',
  SCHEDULED_FOR_X: 'Scheduled for {value}',
  SCHEDULED_ORDER: 'Scheduled Order',
  SCHEDULED_ORDERS: 'Scheduled Orders',
  SCHEDULED_REVIEW: 'Scheduled',
  SEARCH: 'Search',
  SEARCH_FOOD: 'Search food',
  SEARCH_ORDERS: 'Search Orders',
  SEE_ALL_F: 'See All',
  SELECTING_DIFFERENT_LOCATION_CLEAR_CART: 'Changing locations will clear your cart of its items.',
  SELECT_ALL: 'Select All',
  SELECT_AN_OPTION: 'Select an Option',
  SELECT_A_REASON: 'Select a reason',
  SELECT_AT_LEAST: 'Select at least {count}',
  SELECT_BETWEEN: 'Select {min} to {max}',
  SELECT_EXACTLY: 'Select exactly {count}',
  SELECT_N: 'Select {count}',
  SELECT_UP_TO: 'Select up to {count}',
  SELECT_DELIVERY_ADDRESS: 'Select a delivery address',
  SELECT_DELIVERY_ADDRESS_CONTINUE: 'Select a delivery address to continue',
  SELECT_IMAGE: 'Select Image',
  SELECT_LOCATIONS_MIN_ONE: 'Select locations (Select at least one)',
  SELECT_LOCATION_NEAR: 'Select a Location Near',
  SELECT_LOCATION_TO_ORDER: 'Select a location to start ordering',
  SELECT_OPTION: 'Select an Option',
  SELECT_ORDER_REJECT_REASON: 'Select reason for rejecting order',
  SELECT_PICKUP_LOCATION: 'Select a pickup location',
  SELECT_TIME: 'Select Time',
  SELECT_X_DAY: 'Select {value} day',
  SELECT_X_FREE: 'Select <b>{value}</b> free',
  SELECT_X_TIME: 'Select {value} time',
  SETTINGS: 'Settings',
  SET_AS_DEFAULT_X: 'Set as Default { value }',
  SET_AS_PRIMARY: 'Set as primary',
  SET_AS_PRIMARY_ADDRESS: 'Set as primary address',
  SET_AS_PRIMARY_PAYMENT_METHOD: 'Set as primary payment method',
  SHIPPING_CALCULATED_CHECKOUT: 'Shipping and taxes calculated at checkout.',
  SHOPPING_CART: 'Shopping Cart',
  SHORT_DATE_WITH_TIME: '{date} {\'@\'} {time}',
  SHOW_DETAILS: 'Show Details',
  SHOW_STATS_FOR: 'Show stats for',
  SIGNED_IN_AS: 'Signed in as',
  SIGN_IN_ACCOUNT: 'Sign in to your account',
  SIGN_UP: 'Sign Up',
  SMS_ORDER_SCHEDULED: 'An order has been scheduled for {date} for {locationName}',
  SMS_READY_PICKUP_ECOM_ORDER: 'Your order is ready for pickup at {name} - {address}',
  SMS_REFUND_ECOM_ORDER: 'We have issued a refund of {value} for Order #{orderId}',
  SOMETHING_WENT_WRONG: 'Sorry! Something went wrong. Please try again later.',
  SPECIAL_INSTRUCTIONS: 'Special Instructions',
  SPECIAL_INSTRUCTIONS_DISCLAIMER: 'Please note that special requests may result in price adjustments after your order is processed.',
  SPICY_EXTRA: 'Spicy: Extra Hot',
  SPICY_HOT: 'Spicy: Hot',
  SPICY_MEDIUM: 'Spicy: Medium',
  SPICY_MILD: 'Spicy: Mild',
  START_DATE: 'Start Date',
  START_TYPING: 'Start typing...',
  STATE: 'State/Province',
  STATE_REQ: 'State is required',
  STATUS: 'Status',
  STORES_NEAR_X: 'Stores near {value}',
  STORE_IS_CURRENTLY_CLOSED: 'Store is currently closed',
  STREET_ADDRESS: 'Street Address',
  SUBMIT: 'Submit',
  SUBTOTAL: 'Subtotal',
  SUITE_APT_ETC: 'Suite, apartment, etc.',
  SUN: 'Sunday',
  SUNDAY: 'Sunday',
  SUPER_ADMIN: 'Super Admin',
  SUPER_ADMINS: 'Super Admins',
  TAP_FIND_NEAREST_LOCATION: 'Tap here to find the nearest location',
  TAXES: 'Taxes',
  TAXES_FEES: 'Taxes and fees',
  TAX_RATE: 'Tax Rate',
  TECHNICAL_ERROR: 'Technical Error',
  TERMS_OF_SERVICE: 'Terms of Service',
  THANK_YOU: 'Thank You!',
  THIS_WEEK: 'This Week',
  THU: 'Thursday',
  THURSDAY: 'Thursday',
  TIME: 'Time',
  TIMEZONE: 'Timezone',
  TIP: 'Tip',
  TIP_AMOUNT: 'Tip Amount',
  TODAY: 'Today',
  TOKEN_EXPIRED_48_HOURS: 'This link expired after 48 hours',
  TOKEN_EXPIRED_DESC: 'The link you are trying to access is no longer available. You may request a new link',
  TOTAL: 'Total',
  TOTAL_ORDERS: 'Total Orders',
  TOTAL_PAID_ORDERS: 'Total Paid Orders',
  TOTAL_REVENUE: 'Total Revenue',
  TO_YOUR_ACCOUNT_OR: 'to your account or',
  TRY_PLACE_ORDER_AGAIN: 'You may try to place your order again',
  TUE: 'Tuesday',
  TUESDAY: 'Tuesday',
  TWENTY_FOUR_HOURS: '24 hours',
  UNABLE_PROCESS_PAYMENT_DESC: 'There was an error processing the payment for your order. We apologize for any inconvenience. You will not be charged.',
  UNABLE_PROCESS_PAYMENT_HEADLINE: 'We were unable to process payment',
  UNABLE_TO_ADD_PAYMENT_METHOD: 'Invalid card number',
  UNARCHIVE_ACCOUNT: 'Unarchive Account',
  UNARCHIVE_LOCATION: 'Unarchive Location',
  UN_SELECT_ALL: 'Un-Select All',
  UPDATE: 'Update',
  USER: 'User',
  USERNAME: 'Username',
  USERS: 'Users',
  USER_ACCESS: 'User Access',
  USER_ALREADY_EXISTS: 'A user with that email already exists',
  USER_HAS_NO_EMAIL: 'User has no email',
  USER_PERMISSIONS: 'User Permissions',
  USER_PERMISSIONS_DESC: 'Manage user permissions to grant or remove access to dashboard features depending on the user role.',
  VEGAN: 'Vegan',
  VEGETARIAN: 'Vegetarian',
  VIEW: 'View',
  VIEWS: 'Views',
  VIEW_ALL: 'View All',
  VIEW_ALL_F: 'View All',
  VIEW_MAP: 'View Map',
  VIEW_MORE: 'View More',
  VIEW_ORDER: 'View Order',
  VIEW_ORDER_HISTORY: 'View Order History',
  VIEW_OUR_MENU_URL: 'To view our menu, visit { value }.',
  VIEW_PAYOUTS_ON_STRIPE: 'View Payouts on Stripe',
  VIEW_RECEIPT: 'View Receipt',
  VIEW_STORE_INFO: 'View store info',
  VIEW_STRIPE_ACCOUNT: 'View Stripe Account',
  WAITING_FOR_DRIVER: 'Waiting for driver location...',
  WARN_MIN_ORDER_CHECKOUT: 'Just need {value} more to place an order',
  WED: 'Wednesday',
  WEDNESDAY: 'Wednesday',
  WE_SENT_AN_EMAIL_TO: 'We sent an email to',
  WRITE_INSTRUCTIONS: 'Write your instructions',
  WRITE_SPECIAL_INSTRUCTIONS: 'Write your special instructions...',
  X_AMOUNT_FROM_FREE_DELIVERY: 'Only <b>{amount}</b> away from free delivery!',
  X_FOR_Y: '{name} for {value}',
  X_ITEMS: '{value} Items',
  X_ITEMS_IN_YOUR_BAG: '{value} items in your bag',
  X_MINUTES: '{value} minutes',
  X_MIN_AMOUNT_DELIVERY: '{value} minimum purchase for delivery',
  X_ORDERS: '{amount} Orders',
  X_SELECTED_F: '{value} selected',
  X_SELECTED_M: '{value} selected',
  X_TIP: '{value}% tip',
  YES: 'Yes',
  YESTERDAY: 'Yesterday',
  YES_DELETE: 'Yes, Delete',
  YOUR_ADDRESSES: 'Your Addresses',
  YOUR_DRIVER: 'Your driver',
  YOUR_ORDER: 'Your Order',
  YOUR_ORDER_BEING_PREPARED: '<b>Your order</b> is being prepared',
  YOUR_ORDER_BEING_PROCESSED: '<b>Your order</b> is being processed',
  YOUR_ORDER_ON_WAY_DELIVERY: '<b>Your order</b> is on its way',
  YOUR_ORDER_READY_DELIVERY: '<b>Your order</b> is done cooking',
  YOUR_ORDER_READY_PICKUP: '<b>Your order</b> is ready to be picked up',
  YOUR_ORDER_REFUNDED: '<b>Your order</b> was refunded',
  YOUR_PAYMENT_METHODS: 'Your Payment Methods',
  YOU_HAVE_NO_ADDRESSES: 'You have no addresses',
  ZIP_CODE: 'ZIP code',
}

export default en
